"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericViewFields = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const ViewFieldKey_1 = __importDefault(require("../ViewFieldKey"));
exports.GenericViewFields = {
    [ViewFieldKey_1.default.QUESTIONANSWER]: undefined,
    [ViewFieldKey_1.default.ROWKEY]: {
        key: ViewFieldKey_1.default.ROWKEY,
        fieldType: BasicFieldType_1.default.ROW_KEY,
        propertyName: 'allops',
        label: () => '',
        description: () => '',
        sortable: false,
        width: 35,
        gqlFields: '',
    },
    [ViewFieldKey_1.default.ID]: {
        key: ViewFieldKey_1.default.ID,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'id',
        label: () => lib_i18n_1.default.t('id'),
        description: () => lib_i18n_1.default.t('id-description'),
        sortable: true,
        width: 200,
        gqlFields: 'id',
    },
    [ViewFieldKey_1.default.UPDATEDDATE]: {
        key: ViewFieldKey_1.default.UPDATEDDATE,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'updatedDate',
        label: () => lib_i18n_1.default.t('updated'),
        description: () => lib_i18n_1.default.t('updated-description'),
        sortable: true,
        width: 150,
        gqlFields: 'updatedDate',
    },
    [ViewFieldKey_1.default.CREATEDDATE]: {
        key: ViewFieldKey_1.default.CREATEDDATE,
        fieldType: BasicFieldType_1.default.DATE,
        propertyName: 'createdDate',
        label: () => lib_i18n_1.default.t('created'),
        description: () => lib_i18n_1.default.t('created-description'),
        sortable: true,
        width: 150,
        gqlFields: 'createdDate',
    },
    [ViewFieldKey_1.default.DESCRIPTION]: {
        key: ViewFieldKey_1.default.DESCRIPTION,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'description',
        label: () => lib_i18n_1.default.t('description'),
        sortable: false,
        width: 240,
        gqlFields: 'description',
    },
    [ViewFieldKey_1.default.TITLE]: {
        key: ViewFieldKey_1.default.TITLE,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'title',
        label: () => lib_i18n_1.default.t('title'),
        description: () => lib_i18n_1.default.t('title-description'),
        sortable: true,
        width: 240,
        gqlFields: 'title',
    },
    [ViewFieldKey_1.default.TITLEALT]: {
        key: ViewFieldKey_1.default.TITLEALT,
        fieldType: BasicFieldType_1.default.STRINGALT,
        propertyName: 'titleAlt',
        label: () => lib_i18n_1.default.t('title'),
        description: () => lib_i18n_1.default.t('title-description'),
        sortable: true,
        width: 240,
        gqlFields: 'title, titleAlt',
    },
    [ViewFieldKey_1.default.TEAM]: {
        key: ViewFieldKey_1.default.TEAM,
        fieldType: BasicFieldType_1.default.STRING,
        propertyName: 'team.title',
        label: () => lib_i18n_1.default.t('team'),
        description: () => lib_i18n_1.default.t('team-description'),
        sortable: false,
        width: 150,
        gqlFields: 'team { id, title }',
    },
    [ViewFieldKey_1.default.PLACE]: {
        key: ViewFieldKey_1.default.PLACE,
        fieldType: BasicFieldType_1.default.RELATED_PLACE,
        propertyName: 'place.title',
        label: () => lib_i18n_1.default.t('place'),
        description: () => lib_i18n_1.default.t('place-description'),
        sortable: false,
        width: 150,
        gqlFields: 'place { id, title, timezone }',
    },
    [ViewFieldKey_1.default.ASSIGNED_PLACES]: {
        key: ViewFieldKey_1.default.ASSIGNED_PLACES,
        fieldType: BasicFieldType_1.default.RELATED_PLACE,
        propertyName: 'places',
        allPropertyName: 'allPlaces',
        alllabel: () => lib_i18n_1.default.t('all-places'),
        label: () => lib_i18n_1.default.t('places'),
        description: () => lib_i18n_1.default.t('places-description'),
        sortable: false,
        width: 150,
        gqlFields: 'places { id, title, timezone }, allPlaces',
    },
    [ViewFieldKey_1.default.ASSIGNED_TEAMS]: {
        key: ViewFieldKey_1.default.ASSIGNED_TEAMS,
        fieldType: BasicFieldType_1.default.RELATED_MODEL,
        propertyName: 'teams',
        allPropertyName: 'allTeams',
        alllabel: () => lib_i18n_1.default.t('all-teams'),
        label: () => lib_i18n_1.default.t('teams'),
        description: () => lib_i18n_1.default.t('teams-description'),
        sortable: false,
        width: 150,
        gqlFields: 'teams { id, title }, allTeams',
    },
};
exports.default = exports.GenericViewFields;
